// Shared inner body for the Oscar account email-history list page. Renders
// inside AccountPageBody (the account side-nav shell) without the document
// chrome -- each site wraps this in its own PageSkeleton so the DOM is
// byte-identical to the pre-move AccountPageShell.
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { AccountPageBody } from "../AccountPageBody";
import { Pagination } from "../Pagination";

type IProps = Immutable<templates.EmailListDocumentTemplate>;

export const EmailListBody = (props: IProps): React.JSX.Element => {
    const {
        emails,
        empty_message,
        subject_header_label,
        date_sent_header_label,
        pagination,
    } = props;
    return (
        <AccountPageBody sideNav={props.side_nav}>
            {emails.length > 0 ? (
                <>
                    <table className="table table-striped table-bordered">
                        <thead>
                            <tr>
                                <th>{subject_header_label}</th>
                                <th>{date_sent_header_label}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {emails.map((email, i) => (
                                <tr key={i}>
                                    <td>
                                        <a href={email.detail_url}>
                                            {email.subject}
                                        </a>
                                    </td>
                                    <td>{email.date_sent}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {pagination && <Pagination data={pagination} />}
                </>
            ) : (
                <p>{empty_message}</p>
            )}
        </AccountPageBody>
    );
};
